import { render, staticRenderFns } from "./preview-course.vue?vue&type=template&id=399bea0f&scoped=true"
import script from "./preview-course.vue?vue&type=script&lang=js"
export * from "./preview-course.vue?vue&type=script&lang=js"
import style0 from "./preview-course.vue?vue&type=style&index=0&id=399bea0f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399bea0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('399bea0f')) {
      api.createRecord('399bea0f', component.options)
    } else {
      api.reload('399bea0f', component.options)
    }
    module.hot.accept("./preview-course.vue?vue&type=template&id=399bea0f&scoped=true", function () {
      api.rerender('399bea0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/preview-course.vue"
export default component.exports